import React, { useEffect, useState } from "react";
import { Filter, FloatRight, ListView, PagesHeader } from "../../components/Categories";
import { useSelector, useDispatch } from "react-redux";
import { Tabs } from "antd";
import Page from "../../components/Common/Page";
import { getCategoriesList } from "../../appRedux/actions/categories";
import DomainList from "../Domain/List";

const CategoryList = () => {
  const dispatch = useDispatch();
  const [initialFetchComplete, setInitialFetchComplete] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [viewStatus, setViewStatus] = useState("listView");
  const categoryList = useSelector((state) => state.categories.categoryList);

  useEffect(() => {
    dispatch(getCategoriesList({ page: 1, size: 10 })).then(() => {
      setInitialFetchComplete(true);
    });
  }, [dispatch]);

  const items = [
    {
      key: 'categories',
      label: 'Categories',
      children: (
        <>
          <Filter {...{ initialFetchComplete, searchText, setSearchText }} />
          <div className="card">
            <div className="card-body">
              <ListView {...{searchText}}/>
            </div>
          </div>
        </>
      ),
    },
    {
      key: 'domains',
      label: 'Domains',
      children: (
        <div className="card">
          <div className="card-body">
            <DomainList />
          </div>
        </div>
      ),
    },
  ];

  return (
    <Page title="Category">
      <div className="page-wrapper">
        <div className="content container-fluid">
          <PagesHeader
            pageTitle={"Category & Domain Management"}
            homePageUrl="/"
            homePageText="Dashboard"
            activePageText={"Categories"}
            floatRight={
              <FloatRight viewStatus={viewStatus} onChange={(status) => setViewStatus(status)} />
            }
          />
          <Tabs defaultActiveKey="categories" items={items} />
        </div>
      </div>
    </Page>
  );
};

export default CategoryList;
